import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=6a60a9d7&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports